// モーダルのトリガー要素を保存する
let triggerElement;
// スクロール位置を保存する
let scrollAmount;

const selector = {
  trigger: 'main a:not([href*="ana.co.jp"])[target="_blank"]', // モーダルのトリガー要素（CSSセレクター）
  cloneContent: '#v1-permission-clone', // モーダルに挿入するクローン対象のコンテンツ（CSSセレクター）
  disagreeButton: 'v1-permission-disagree', // モーダルを閉じるボタン（ID）
  agreeButton: 'v1-permission-agree', // URLへ遷移するボタン（ID）
  modalID: 'v1-permission', // コンテンツを挿入する要素（ID）
  contentID: 'v1-permission-content', // コンテンツを挿入する要素（ID）
  focusID: 'v1-permission-focus', // モーダルを開くときにフォーカスする要素（ID）
  overlayID: 'v1-permission-overlay', // モーダルの背景要素（ID）
};

/**
 * モーダルコンポーネントです。
 * @param trigger {string} モーダルのトリガー要素（CSSセレクター）
 * @param cloneContent {string} モーダルに挿入するクローン対象のコンテンツ（CSSセレクター）
 * @param disagreeButton {string} モーダルを閉じる要素（ID）
 * @param content {string} コンテンツを挿入する要素（ID）
 * @param modal {string} モーダルのルート要素（ID）
 * @param focus {string} モーダルを開くときにフォーカスする要素（ID）
 * @param overlay {string} モーダルの背景要素（ID）
 * @param openClass {string} モーダルを開くときに付与するクラス名
 * @param {boolean|function} beforeAgree [false] モーダルを閉じる前に実行するコールバック関数（イベント、トリガー要素）。
 * @param url {string} 遷移するリンク先
 */
export default class PermissionModal {
  constructor(options) {
    const defaultOptions = {
      trigger: selector.trigger,
      cloneContent: selector.cloneContent,
      disagreeButton: selector.disagreeButton,
      agreeButton: selector.agreeButton,
      content: selector.contentID,
      modal: selector.modalID,
      focus: selector.focusID,
      overlay: selector.overlayID,
      openClass: '-active',
      beforeAgree: false,
      url: '',
    };

    this.options = Object.assign(defaultOptions, options);

    Object.keys(this.options).forEach(key => {
      this[key] = this.options[key];
    });

    this.selector = {
      trigger: document.querySelectorAll(this.trigger),
      cloneContent: document.querySelectorAll(this.cloneContent),
      disagreeButton: document.getElementById(this.disagreeButton),
      agreeButton: document.getElementById(this.agreeButton),
      content: document.getElementById(this.content),
      modal: document.getElementById(this.modal),
      focus: document.getElementById(this.focus),
      overlay: document.getElementById(this.overlay),
    };
  }

  init() {
    if (!this.selector.trigger.length) return;
    this.clickAgree();
    this.clickDisagree();
    this.escapeClose();
    this.overlayClose();
    this.focusTrap();
  }

  open(url) {
    this.options.url = url;
    triggerElement = document.activeElement;
    scrollAmount = window.pageYOffset;
    this.selector.modal.setAttribute('aria-hidden', 'false');
    const content = document.querySelector(this.cloneContent);
    const clonedContent = content.cloneNode(true);
    clonedContent.removeAttribute('id');
    this.selector.content.textContent = '';
    this.selector.content.insertAdjacentElement('afterbegin', clonedContent);
    this.selector.modal.classList.add(this.openClass);
    setTimeout(() => {
      this.selector.focus.focus();
    }, 100);
  }

  close() {
    window.scrollTo(0, scrollAmount);
    this.selector.focus.scrollTop = 0;
    this.selector.modal.setAttribute('aria-hidden', 'true');
    this.selector.modal.classList.remove(this.openClass);

    setTimeout(() => {
      triggerElement.focus();
    }, 0);
  }

  clickDisagree() {
    this.selector.disagreeButton.addEventListener('click', () => {
      this.close();
    });
  }

  clickAgree() {
    this.selector.agreeButton.addEventListener('click', event => {
      if (this.beforeAgree !== false) {
        this.beforeAgree(event, this.options.url);
      }

      this.close();
    });
  }

  overlayClose() {
    this.selector.overlay.addEventListener('click', () => {
      this.close();
    });
  }

  escapeClose() {
    document.addEventListener('keyup', event => {
      const isEsc = !!(event.key === 'Escape' || event.key === 'Esc');
      if (isEsc) {
        this.close();
      }
    });
  }

  /**
   * モーダル要素内のフォーカス可能な要素で循環する。
   * @return {void}
   */
  focusTrap() {
    document.addEventListener('keydown', event => {
      const focusable = this.focusableElements();
      const isTab = !event.shiftKey && event.key === 'Tab';
      const isShiftTab = event.shiftKey && event.key === 'Tab';

      if (isTab && document.activeElement === focusable.last) {
        event.preventDefault();
        focusable.first.focus();
      }
      if (isShiftTab && document.activeElement === focusable.first) {
        event.preventDefault();
        focusable.last.focus();
      }
    });
  }

  /**
   * モーダル内のフォーカス可能な最初と最後、すべての要素を返す。
   * @return {Object} first, last, all - 最初の要素、最後の要素、すべての要素
   */
  focusableElements() {
    const elements = document.querySelectorAll(
      `#${this.modal} a, #${this.modal} button, #${this.modal} input, #${this.modal} textarea, #${this.modal} select, #${this.modal} details, #${this.modal} [tabindex]:not([tabindex="-1"])`,
    );
    return {
      first: elements[0],
      last: elements[elements.length - 1],
      all: elements,
    };
  }
}
